import isEmpty from 'lodash/isEmpty';
import {
  PERSONAL_INFO_QUESTIONNAIRES,
  PAYMENT_INFORMATION_QUESTIONNAIRES,
  SECURITY_INFORMATION_QUESTIONNAIRES,
  SCHOOL_INFORMATION_QUESTIONNAIRES,
  FINISH_INFORMATION_QUESTIONNAIRES,
} from '@thinknet-gmbh/platform-common';

import { QUESTIONNAIRE_FORM_STEPS } from './questionnaire-page.constants';

export const getValidFormData = (settings: string[]) => {
  const categories = {
    employeePersonalInfo: PERSONAL_INFO_QUESTIONNAIRES,
    paymentAndInsurance: PAYMENT_INFORMATION_QUESTIONNAIRES,
    educationAndSkills: SCHOOL_INFORMATION_QUESTIONNAIRES,
    emergencyContact: SECURITY_INFORMATION_QUESTIONNAIRES,
    finishInformation: FINISH_INFORMATION_QUESTIONNAIRES,
  };

  const result: Record<string, string[]> = {
    employeePersonalInfo: [],
    paymentAndInsurance: [],
    educationAndSkills: [],
    emergencyContact: [],
    finishInformation: [],
  };

  settings.forEach(el => {
    for (const [category, questionnaire] of Object.entries(categories)) {
      if (questionnaire[el as keyof typeof questionnaire]) {
        result[category].push(el);
      }
    }
  });

  return result;
};

export const getStepsData = ({
  employeePersonalInfo,
  emergencyContact,
  educationAndSkills,
  paymentAndInsurance,
  finishInformation,
}: {
  employeePersonalInfo: string[];
  emergencyContact: string[];
  educationAndSkills: string[];
  paymentAndInsurance: string[];
  finishInformation: string[];
}) => {
  const steps = [];

  if (!isEmpty(employeePersonalInfo)) {
    steps.push(QUESTIONNAIRE_FORM_STEPS.employeePersonalInfo);
  }
  if (!isEmpty(paymentAndInsurance)) {
    steps.push(QUESTIONNAIRE_FORM_STEPS.paymentAndInsurance);
  }
  if (!isEmpty(educationAndSkills)) {
    steps.push(QUESTIONNAIRE_FORM_STEPS.educationAndSkills);
  }
  if (!isEmpty(emergencyContact)) {
    steps.push(QUESTIONNAIRE_FORM_STEPS.emergencyContact);
  }

  if (!isEmpty(finishInformation)) {
    steps.push(QUESTIONNAIRE_FORM_STEPS.finishInformation);
  }

  const totalStepsCount = steps.length > 0 ? steps.length - 1 : 0;

  return { steps, totalStepsCount };
};
